// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...
	$w("#tabButton1").onClick( (event) => {
		$w("#statebox8").changeState("Tab1");
		$w('#box10').show();
		$w('#box11').hide();
		$w('#box12').hide();
	});

	$w("#tabButton2").onClick((event) => {
		$w("#statebox8").changeState("Tab2");
		$w('#box10').hide();
		$w('#box11').show();
		$w('#box12').hide();
	});

	$w("#tabButton3").onClick((event) => {
		$w("#statebox8").changeState("Tab3");
		$w('#box10').hide();
		$w('#box11').hide();
		$w('#box12').show();
	});
});